import React, { FC, ReactNode } from 'react';
import { selectActionResult } from '../../consentSelectors';
import { ResultStatus } from '../../types';
import { ErrorRequest } from './components/ErrorRequest';
import { SuccessUpdatePreferences } from './components/SuccessUpdateConsent';
import { useAppSelector } from '../../../../hooks';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { PageWrapper } from '../../../../components/PageWrapper';

const styles = css({
  padding: `0px ${token('space.400')} ${token('space.200')}`,
  display: 'flex',
  justifyContent: 'center',
  marginTop: token('space.100'),
  marginBottom: token('space.200'),
});

const resolveActionResultStatus = (status: ResultStatus, data: string | undefined): ReactNode => {
  switch (status) {
    case 'success':
      return <SuccessUpdatePreferences data={data} />;
    case 'error':
      return <ErrorRequest />;
  }
};

const ActionNotification: FC = () => {
  const actionResult = useAppSelector(selectActionResult);

  if (actionResult == null) return null;

  const notification = resolveActionResultStatus(actionResult.status, actionResult.action);

  return (
    <PageWrapper>
      <div data-testid='consent-action-notification' css={styles}>
        {notification}
      </div>
    </PageWrapper>
  );
};

export default ActionNotification;
